// extracted by mini-css-extract-plugin
module.exports = {"tnc-wrapper":"LoginTnc_tnc-wrapper__7NgqG"};